module.exports = __webpack_public_path__ + "img/image3.2b562dc4.svg";